import Vue from "vue";
import axios from "axios";

import Modal from "../vue/components/Modal.vue";
export default {
  init() {
    new Vue({
      components: { Modal },
      el: ".faq-form",
      data() {
        return {
          isLoading: false,
          openModal: false,
          faqRecaptcha: false,
          form: {},
        };
      },

      methods: {
        submit() {
          this.faqRecaptcha = false
          if (grecaptcha.getResponse(faqRecaptcha).length !== 0) {
            this.isLoading = true;
            this.form.grecaptcha = grecaptcha.getResponse(faqRecaptcha);
            axios
              .post(`${LTM.api.url}v1/faqs`, this.form)
              .then(({ data }) => {
                this.openModal = true;
                this.form = {};
              })
              .catch((error) => { })
              .then(() => {
                this.isLoading = false;
                grecaptcha.reset(faqRecaptcha)
              });
          }
          else {
            this.faqRecaptcha = true
          }
        },
      },
    });
  },
  finalize() { },
};
